import { Redirect, Stack, useGlobalSearchParams } from 'expo-router';

import { useSession } from '@/components/session-provider';
import { authDestination } from '@/lib/auth-return';

export default function PublicLayout() {
  const { session, isLoading } = useSession();
  const { returnTo } = useGlobalSearchParams<{ returnTo?: string | string[] }>();

  if (!isLoading && session) {
    return <Redirect href={authDestination(returnTo)} />;
  }

  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="sign-in" options={{ headerShown: false }} />
      <Stack.Screen
        name="sign-up"
        options={{ headerShown: process.env.EXPO_OS !== 'web', title: 'Sign up' }}
      >
        <Stack.Screen.BackButton displayMode="minimal" />
      </Stack.Screen>
      <Stack.Screen
        name="forgot-password"
        options={{ headerShown: process.env.EXPO_OS !== 'web', title: 'Reset password' }}
      >
        <Stack.Screen.BackButton displayMode="minimal" />
      </Stack.Screen>
      <Stack.Screen
        name="reset-password"
        options={{ headerShown: process.env.EXPO_OS !== 'web', title: 'New password' }}
      >
        <Stack.Screen.BackButton displayMode="minimal" />
      </Stack.Screen>
      <Stack.Screen
        name="verify-email"
        options={{ headerShown: process.env.EXPO_OS !== 'web', title: 'Verify email' }}
      >
        <Stack.Screen.BackButton displayMode="minimal" />
      </Stack.Screen>
    </Stack>
  );
}
